export function ElementsStyles() {
	return (
		<style global jsx>
{`.dark h1, .dark h2, .dark h3, .dark h4, .dark h5, .dark h6 {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
h1 a, h2 a, h3 a, h4 a, h5 a, h6 a {
  border-style: none;
  float: left;
  margin-top: 0.125rem;
  margin-left: -1.25rem;
  opacity: 0;
  padding-right: 0.5rem;
  text-decoration: none;
}
h1 a .icon-link:before, h2 a .icon-link:before, h3 a .icon-link:before, h4 a .icon-link:before, h5 a .icon-link:before, h6 a .icon-link:before {
  content: '#';
}
h1:hover a, h1:focus a, h2:hover a, h2:focus a, h3:hover a, h3:focus a, h4:hover a, h4:focus a, h5:hover a, h5:focus a, h6:hover a, h6:focus a {
  opacity: 1;
  text-decoration: none;
}
a {
  border-radius: 0.25rem;
  text-decoration: none;
  -webkit-transition-property: background-color, border-color, color, fill, stroke, opacity, -webkit-box-shadow, -webkit-transform, filter, backdrop-filter;
  -o-transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, -webkit-box-shadow, transform, -webkit-transform, filter, backdrop-filter;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -o-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-transition-duration: 150ms;
  -o-transition-duration: 150ms;
  transition-duration: 150ms;
  -webkit-transition-duration: 300ms;
  -o-transition-duration: 300ms;
  transition-duration: 300ms;
}
a:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  -webkit-box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-offset-width: 2px;
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(103, 58, 183, var(--tw-ring-opacity));
}
.dark a {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
a .item {
  border-bottom-width: 0px;
  opacity: 0.6;
  text-decoration: none;
  -webkit-transition-property: background-color, border-color, color, fill, stroke, opacity, -webkit-box-shadow, -webkit-transform, filter, backdrop-filter;
  -o-transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, -webkit-box-shadow, transform, -webkit-transform, filter, backdrop-filter;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -o-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-transition-duration: 150ms;
  -o-transition-duration: 150ms;
  transition-duration: 150ms;
  -webkit-transition-duration: 300ms;
  -o-transition-duration: 300ms;
  transition-duration: 300ms;
}
a .item:hover {
  opacity: 1;
}
p, ul, li {
  --tw-text-opacity: 1;
  color: rgba(105, 108, 113, var(--tw-text-opacity));
}
.dark strong {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
img {
  border-radius: 1.5rem;
  -o-object-fit: cover;
  object-fit: cover;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-transition-property: background-color, border-color, color, fill, stroke, opacity, -webkit-box-shadow, -webkit-transform, filter, backdrop-filter;
  -o-transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, -webkit-box-shadow, transform, -webkit-transform, filter, backdrop-filter;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -o-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-transition-duration: 150ms;
  -o-transition-duration: 150ms;
  transition-duration: 150ms;
  -webkit-transition-duration: 300ms;
  -o-transition-duration: 300ms;
  transition-duration: 300ms;
}
img:hover {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0/0.1),0 8px 10px -6px rgb(0 0 0/0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color),0 8px 10px -6px var(--tw-shadow-color);
  -webkit-box-shadow: var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow);
}
figcaption {
  text-align: center;
  --tw-text-opacity: 1;
  color: rgba(202, 203, 205, var(--tw-text-opacity));
}
.dark figcaption {
  --tw-text-opacity: 1;
  color: rgba(105, 108, 113, var(--tw-text-opacity));
}
.dark hr {
  --tw-border-opacity: 1;
  border-color: rgba(36, 41, 47, var(--tw-border-opacity));
}
hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
code {
  --tw-bg-opacity: 1;
  background-color: rgba(234, 234, 235, var(--tw-bg-opacity));
  border-radius: 0.25rem;
  padding: 0.25rem;
  --tw-text-opacity: 1;
  color: rgba(105, 108, 113, var(--tw-text-opacity));
}
.dark code {
  --tw-bg-opacity: 1;
  background-color: rgba(24, 27, 32, var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgba(202, 203, 205, var(--tw-text-opacity));
}
code:after, code:before {
  display: none;
}
pre {
  --tw-bg-opacity: 1;
  background-color: rgba(202, 203, 205, var(--tw-bg-opacity));
  --tw-border-opacity: 1;
  border-color: rgba(234, 234, 235, var(--tw-border-opacity));
  border-radius: 0.5rem;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border-width: 2px;
  margin: 0px;
}
.dark pre {
  --tw-bg-opacity: 1;
  background-color: rgba(18, 21, 24, var(--tw-bg-opacity));
  --tw-border-opacity: 1;
  border-color: rgba(40, 45, 52, var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
.dark th {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
.dark td {
  --tw-text-opacity: 1;
  color: rgba(105, 108, 113, var(--tw-text-opacity));
}
.dark ol li::before {
  --tw-text-opacity: 1;
  color: rgba(167, 169, 172, var(--tw-text-opacity));
}
.light .remark-code-title {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}
.remark-code-title {
  --tw-border-opacity: 1;
  border-color: rgba(234, 234, 235, var(--tw-border-opacity));
  border-radius: 0.5rem;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
  border-width: 2px;
  border-bottom-width: 0px;
  font-weight: 500;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  --tw-text-opacity: 1;
  color: rgba(167, 169, 172, var(--tw-text-opacity));
}
.dark .remark-code-title {
  --tw-border-opacity: 1;
  border-color: rgba(40, 45, 52, var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
`}</style>
	);
}
